import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { DestroyComponent } from '../../destroy-component/destroy-component';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error.modal.html'
})
export class ErrorModalComponent extends DestroyComponent {

  constructor(
    public dialogRef: MatDialogRef<ErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { errorMessage: string }
  ) {
    super();
  }

  onClose(): void {
    this.dialogRef.close();
    window.location.href = environment.logoutUrl;
  }
}

